import { AfterViewInit, Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { add } from 'date-fns';
import { DateService } from 'src/app/services/date.service';

@Component({
  selector: 'app-warranty-view',
  templateUrl: './warranty-view.component.html',
  styleUrls: ['./warranty-view.component.css']
})
export class WarrantyViewComponent implements OnInit, OnChanges {

  @Input() warranty: Date;
  @Input() warrantyMonth: number;
  @Input() warrantyYear: number;
  @Input() warrantyLastUpdate: Date;
  @Input() warrantyActive: number;
  @Input() warrantyProgress: number;
  @Input() warrantyCurrent: any;
  @Input() warrantyEnd: any;
  @Input() flex = 'column';
  @Input() createdAt: Date;

  today = new Date();

  constructor(
    private dateService: DateService,
  ) { }

  ngOnInit(): void {
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.warrantyYear || this.warrantyMonth){
      this.warranty = add(new Date(), { years: this.warrantyYear, months: this.warrantyMonth })
    }

    if (!this.warrantyProgress){
      this.progressWarranty(this.warranty);
    }
  }

  // Função par auxiliar na criação da barra de progresso de garantia
  progressWarranty(warranty): void {
    if (warranty) {
      const now = new Date();
      this.warrantyEnd = this.dateService.getRelativeTime(
        warranty,
        this.createdAt ?? now,
      );

      this.warrantyCurrent = this.dateService.getRelativeTime(warranty, now);

      if (this.warrantyEnd[0] || this.warrantyCurrent[0]) {
        this.warrantyProgress = this.warrantyCurrent[0] / this.warrantyEnd[0];
      } else {
        this.warrantyProgress = 0;
      }

      if (this.warrantyProgress <= 0) {
        // Sem garantia
        this.warrantyActive = 3;
      } else {
        if (this.dateService.isWithinEndOfWarranty(this.warrantyCurrent)) {
          // Dentro da janela "fim de garantia" da organização
          this.warrantyActive = 2;
        } else {
          this.warrantyActive = 1;
        }
      }
    } else {
      this.warrantyActive = undefined;
      this.warrantyProgress = undefined;
    }

  }
}
